// extracted by mini-css-extract-plugin
export default {"info":"_2a55d5cb","associations":"_204b590f","associationsList":"_b5a2c8cd"};